import { RestQueryHookOptions, useRestPostQuery } from 'utils/hooks/api';

const RETEST_SPAM_REPORT_URL = '/templates/retest?templateId=';

export const useRetestSpamReportQuery = (templateId?: number, options?: RestQueryHookOptions) => {
  const url = `${RETEST_SPAM_REPORT_URL}${templateId}`;
  return useRestPostQuery(url, {}, options);
};
